var core = require('./lib/core');
exports = module.exports = require('./lib/async');
exports.core = core;
exports.isCore = function (x) { return core[x] };
exports.sync = require('./lib/sync');



//////////////////
// WEBPACK FOOTER
// ./~/istanbul/~/resolve/index.js
// module id = 3120
// module chunks = 0